import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
export const Collapsible = (props)=>{
    const ref = React.useRef(null);
    const [expanded, setExpanded] = React.useState(false);
    const [isClamped, setIsClamped] = React.useState(false);
    // Measured once while collapsed (clamped) so expanding doesn't flip clientHeight === scrollHeight and hide the toggle
    React.useEffect(()=>{
        const el = ref.current;
        if (el) setIsClamped(el.scrollHeight > el.clientHeight);
    }, [
        props.children
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "event-page__description",
        children: [
            /*#__PURE__*/ _jsx("div", {
                ref: ref,
                className: `event-page__description-text${expanded ? '' : ' event-page__description-text--collapsed'}`,
                children: props.children
            }),
            (isClamped || expanded) && /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: "event-page__read-more",
                onClick: ()=>setExpanded((v)=>!v),
                "aria-expanded": expanded,
                children: expanded ? 'Lees minder' : 'Lees meer'
            })
        ]
    });
};
